module.exports = __webpack_public_path__ + "static/t_325_719-bff1071aeab5a845bb331eaeff5862f0.png";